import React from 'react'

import * as SC from './Connector.style'
import { CurvedConnectorLine, DottedConnectorLine, StraightConnectorLine } from './ConnectorLines'

interface ConnectorProps {
  connectorColor?: string
  text: string
}

export const Connector: React.FC<ConnectorProps> = ({ text, connectorColor }) => {
  return (
    <SC.ConnectorWrapper>
      <CurvedConnectorLine color={connectorColor} direction={'up'} />
      <DottedConnectorLine />
      <SC.TextWrapper>
        <SC.Text background={connectorColor}>{text}</SC.Text>
      </SC.TextWrapper>
      <CurvedConnectorLine color={connectorColor} direction={'down'} />
      <StraightConnectorLine color={connectorColor} />
    </SC.ConnectorWrapper>
  )
}
